import { TransportOption, TransportOptionParameterValue } from 'src/tmc-yard/client/model/transport-option';


export class EditableTransportOption extends TransportOption {

  parentId: number;
  selected = false;
  amountOfPallettes: number;
  amountOfBoxes: number;
  amountInKilogramm: number;
  amountInLiter: number;
  amountOthers: string;

  transportOptions = new Array<EditableTransportOption>();
  optionValidity: OptionValidity;

  transportOption: TransportOption;

  selectedParameterValues = new Array<TransportOptionParameterValue>();

  constructor(option: any) {
    super(option);
    this.selected = option.selected;
    this.amountOfPallettes = option?.amountOfPallettes;
    this.amountOfBoxes = option?.amountOfBoxes;
    this.amountInKilogramm = option?.amountInKilogramm;
    this.amountInLiter = option?.amountInLiter;
    this.amountOthers = option?.amountOthers;

    this.optionValidity = option.optionValidity;

    this.transportOption = option;

    if (option.transportOptions != null) {
      for (const to of option.transportOptions) {
        const child = new EditableTransportOption(to);
        child.parentId = this.id;
        this.transportOptions.push(child);
      }
    }

    if (option.selectedParameterValues != null) {
      for (const value of option.selectedParameterValues) {
        this.selectedParameterValues.push(new TransportOptionParameterValue(value));
      }
    }

  }
}

export class OptionsColumn {
  columnIndex: number;
  transportOptions = new Array<EditableTransportOption>();
}

export enum TransportOptionConstraintType {
  MIN_SELECTED_COUNT = 'MIN_SELECTED_COUNT'
}

export class EditableTransportOptionConstraint {
  id: number;
  name: string;
  count: number;
  type = TransportOptionConstraintType.MIN_SELECTED_COUNT;
  transportOptionIds = new Array<number>();

  constructor(constraint: EditableTransportOptionConstraint) {
    this.id = constraint.id;
    this.name = constraint.name;
    this.count = constraint.count;
    this.type = constraint.type;
    if (constraint.transportOptionIds != null) {
      this.transportOptionIds.push(...constraint.transportOptionIds);
    }
  }
}

export enum OptionValidity {
  valid = 'valid', invalid = 'invalid', dependentInvalid = 'dependentInvalid'
}